import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { fetchTestimonials } from "@/lib/api";

const CATS = [
  { key: "all", label: "All" },
  { key: "leadership", label: "Leadership" },
  { key: "emotional-intelligence", label: "Emotional Intelligence" },
  { key: "conflict-management", label: "Conflict Management" },
];

const Testimonials = () => {
  const [cat, setCat] = useState("all");
  const [items, setItems] = useState([]);

  useEffect(() => { fetchTestimonials(cat).then(setItems); }, [cat]);

  return (
    <div data-testid="testimonials-page" className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
      <div className="text-[10px] tracking-[0.28em] uppercase text-[#8C4A57] mb-3">Testimonials</div>
      <h1 className="text-4xl sm:text-5xl font-serif font-semibold text-[#2D2628] mb-4">From leaders who have done the work</h1>
      <p className="text-base text-[#6B5E62] max-w-2xl mb-10 leading-relaxed">
        Reflections from military commanders, executives, and founders who have completed our ebooks and courses.
      </p>

      <div className="flex flex-wrap gap-2 mb-10" data-testid="testimonials-filter">
        {CATS.map((c) => (
          <button key={c.key}
            data-testid={`testimonial-filter-${c.key}`}
            onClick={() => setCat(c.key)}
            className={`px-4 py-2 text-xs uppercase tracking-wider rounded-sm border transition-colors duration-200 ${
              cat === c.key ? "bg-[#8C4A57] border-[#8C4A57] text-white"
                : "bg-white border-[#E8DCDD] text-[#2D2628] hover:border-[#8C4A57] hover:text-[#8C4A57]"
            }`}>
            {c.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {items.map((t) => (
          <div key={t.id} data-testid={`testimonial-${t.id}`}
            className="bg-white border border-[#E8DCDD] rounded-md p-6 sm:p-8 hover:border-[#8C4A57] transition-colors duration-200">
            <div className="flex gap-1 mb-4" data-testid={`testimonial-rating-${t.id}`}>
              {Array.from({ length: t.rating }).map((_, i) => (
                <Star key={i} className="w-4 h-4 text-[#8C4A57] fill-[#8C4A57]" />
              ))}
            </div>
            <p className="text-[#2D2628] font-serif text-lg leading-relaxed mb-6 italic">"{t.quote}"</p>
            <div>
              <div className="font-semibold text-[#2D2628]">{t.name}</div>
              <div className="text-xs text-[#6B5E62] uppercase tracking-wider mt-1">{t.role}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
